import kirigayaSuguha from "../../assets/combatants/isekai-league/kirigaya-suguha.png";
import kirigayaSuguhaIcon from "../../assets/combatants/isekai-league/kirigaya-suguha-icon.png";
import kirigayaSuguhaWin from "../../assets/combatants/isekai-league/kirigaya-suguha-win.png";
import kirigayaSuguhaLose from "../../assets/combatants/isekai-league/kirigaya-suguha-lose.png";

import leafa from "../../assets/combatants/isekai-league/leafa.png";
import leafaIcon from "../../assets/combatants/isekai-league/leafa-icon.png";
import leafaWin from "../../assets/combatants/isekai-league/leafa-win.png";
import leafaLose from "../../assets/combatants/isekai-league/leafa-lose.png";

import sinon from "../../assets/combatants/isekai-league/asada-shino.png";
import sinonIcon from "../../assets/combatants/isekai-league/asada-shino-icon.png";
import sinonWin from "../../assets/combatants/isekai-league/asada-shino-win.png";
import sinonLose from "../../assets/combatants/isekai-league/asada-shino-lose.png";

import KonnoYuuki from "../../assets/combatants/isekai-league/konno-yuuki.png";
import KonnoYuukiIcon from "../../assets/combatants/isekai-league/konno-yuuki-icon.png";
import KonnoYuukiWin from "../../assets/combatants/isekai-league/konno-yuuki-win.png";
import KonnoYuukiLose from "../../assets/combatants/isekai-league/konno-yuuki-lose.png";

import YuukiAsuna from "../../assets/combatants/isekai-league/yuuki-asuna.png";
import YuukiAsunaIcon from "../../assets/combatants/isekai-league/yuuki-asuna-icon.png";
import YuukiAsunaWin from "../../assets/combatants/isekai-league/yuuki-asuna-win.png";
import YuukiAsunaLose from "../../assets/combatants/isekai-league/yuuki-asuna-lose.png";

export const seriesId = "Sword Art Online";

export default {
  leafa: {
    seriesId,
    id: "leafa",
    name: "Leafa",
    description: "She is Kirigaya Suguha's alter ego in ALO.",
    img: leafa,
    icon: leafaIcon,
    opWinImg: leafaWin,
    opLoseImg: leafaLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Elf",
    bodyShape: "soft",
    eyeColor: "green",
    hairColor: "blonde",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 3,
    prefAttack: "tongue",
    prefTarget: "breasts",
    uniqueAttackText:
      "leafa hungril sucking xxxx's nipples and closign her eyes in pleasure.",
    roughPlayLvl: 20,
    seductionResistance: 10,
    grapplingProwess: 25,
    tongueProwess: 20,
    touchProwess: 2,
    cockProwess: 15,
    vaginaProwess: 25,
    anusProwess: 10,
    touchResistance: 15,
    breastResistance: 20,
    mouthResistance: 20,
    cockResistance: 5,
    vaginaResistance: 25,
    anusResistance: 10,
    orgasmLimit: 3,
  },
  kirigayaSuguha: {
    seriesId,
    id: "kirigayaSuguha",
    name: "Kirigaya Suguha",
    description:
      "An accomplished kendo practitioner, fighter, and seasoned ALO player.",
    img: kirigayaSuguha,
    icon: kirigayaSuguhaIcon,
    opWinImg: kirigayaSuguhaWin,
    opLoseImg: kirigayaSuguhaLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "curvy",
    eyeColor: "dark grey",
    hairColor: "black",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 2,
    anusSize: 1,
    throatSize: 3,
    prefAttack: "tongue",
    prefTarget: "breasts",
    uniqueAttackText:
      "Suguha hungrily slathers xxxx's breasts with her tongue, eagerly sucking her nipples and savouring their sweet, sweaty taste.",
    roughPlayLvl: 20,
    seductionResistance: 10,
    grapplingProwess: 25,
    tongueProwess: 25,
    touchProwess: 2,
    cockProwess: 15,
    vaginaProwess: 25,
    anusProwess: 10,
    touchResistance: 15,
    breastResistance: 20,
    mouthResistance: 20,
    cockResistance: 5,
    vaginaResistance: 20,
    anusResistance: 15,
    orgasmLimit: 3,
  },
  sinon: {
    seriesId,
    id: "sinon",
    name: "Sinon",
    description: "She is Asada Shino's alter ego in ALO.",
    img: sinon,
    icon: sinonIcon,
    opWinImg: sinonWin,
    opLoseImg: sinonLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Elf",
    bodyShape: "petite",
    eyeColor: "azure",
    hairColor: "blue",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 1,
    anusSize: 2,
    throatSize: 1,
    prefAttack: "touch",
    prefTarget: "vagina",
    uniqueAttackText:
      "Sinon's delicate fingers explore xxxx's pussy, gently massaging allover.",
    roughPlayLvl: -25,
    seductionResistance: 15,
    grapplingProwess: 20,
    tongueProwess: 20,
    touchProwess: 25,
    cockProwess: 15,
    vaginaProwess: 15,
    anusProwess: 10,
    touchResistance: 15,
    breastResistance: 10,
    mouthResistance: 10,
    cockResistance: 15,
    vaginaResistance: 25,
    anusResistance: 10,
    orgasmLimit: 3,
  },
  konnoYuuki: {
    seriesId,
    id: "konnoYuuki",
    name: "Konno Yuuki",
    description:
      "Known as the absolute sword, She was the younger sister of Konno Aiko and one of the three founders and the 2nd leader of the Sleeping Knights guild,",
    img: KonnoYuuki,
    icon: KonnoYuukiIcon,
    opWinImg: KonnoYuukiWin,
    opLoseImg: KonnoYuukiLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Imp",
    bodyShape: "petite",
    eyeColor: "red",
    hairColor: "dark purple",
    skinColor: "fair",
    height: 1,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 2,
    anusSize: 1,
    throatSize: 1,
    prefAttack: "tongue",
    prefTarget: "cock",
    uniqueAttackText:
      "Greedily Yuuki gobbles up xxxx's cock, sucking on it as hard as she can, hoping to draw every last drop of semen into her throat.",
    roughPlayLvl: 5,
    seductionResistance: 25,
    grapplingProwess: 25,
    tongueProwess: 25,
    touchProwess: 20,
    cockProwess: 15,
    vaginaProwess: 10,
    anusProwess: 20,
    touchResistance: 15,
    breastResistance: 15,
    mouthResistance: 35,
    cockResistance: 15,
    vaginaResistance: 45,
    anusResistance: 10,
    orgasmLimit: 3,
  },
  yuukaAsuna: {
    seriesId,
    id: "yuukaAsuna",
    name: "Yuuka Asuna",
    description:
      "Sub-leader of the Knights of the Blood guild & is a kind and helpful young woman who, cannot abandon another in trouble.",
    img: YuukiAsuna,
    icon: YuukiAsunaIcon,
    opWinImg: YuukiAsunaWin,
    opLoseImg: YuukiAsunaLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "lithe",
    eyeColor: "brown",
    hairColor: "chestnut",
    skinColor: "pale",
    height: 2,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 1,
    anusSize: 2,
    throatSize: 1,
    prefAttack: "touch",
    prefTarget: "breasts",
    uniqueAttackText:
      "Asuna gropes xxxx's breasts roughly, teasing the soft breast-meat and whispering alluring words into her ear.",
    roughPlayLvl: -10,
    seductionResistance: 30,
    grapplingProwess: 25,
    tongueProwess: 25,
    touchProwess: 40,
    cockProwess: 15,
    vaginaProwess: 25,
    anusProwess: 15,
    touchResistance: 35,
    breastResistance: 65,
    mouthResistance: 50,
    cockResistance: 15,
    vaginaResistance: 25,
    anusResistance: 25,
    orgasmLimit: 3,
  },
};
